// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// modules
import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import { createEpicMiddleware } from 'redux-observable'
import { reduxBatch } from '@manaflair/redux-batch'
// reducers and epics
import reducers from './reducers'
import rootEpic from './redux-observable'
import beforeReduxCreate from '../hooks/before/reduxCreate'

export const reduxMainStateKey = 'reduxMainState'

const name = process.env.NODE_ENV === 'development' ? 'IM_DEVELOPMENT' : 'IM'
/* eslint-disable no-underscore-dangle */
const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ name: 'IM' })
    : compose
/* eslint-enable */

// const persistedMain = beforeReduxCreate()
const epicMiddleware = createEpicMiddleware()

// const store = createStore(
// combineReducers(reducers),
// { main: persistedMain, view: {} },
// composeEnhancers(reduxBatch, applyMiddleware(epicMiddleware)),
// )

const store = createStore(
  combineReducers(reducers),
  composeEnhancers(reduxBatch, applyMiddleware(epicMiddleware)),
)

epicMiddleware.run(rootEpic)

/* eslint-disable */
const addLoggingToDispatch = theStore => {
  const rawDispatch = theStore.dispatch
  if (!console.group) return rawDispatch

  // eslint-disable-next-line
  theStore.dispatch = action => {
    console.group(action.type)
    // console.log('%c prev state', 'color: gray', theStore.getState())
    console.log('%c action', 'color: blue', action)
    const returnValue = rawDispatch(action)
    // console.log('%c next state', 'color: green', theStore.getState())
    console.groupEnd(action.type)

    return returnValue
  }
}
// addLoggingToDispatch(store)

/* eslint-enable */

export default store
export const { dispatch, getState } = store

// TODO Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = any //ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type RootDispatch = typeof store.dispatch
